import { render } from "./InventoryValueReport.vue?vue&type=template&id=6a94298c&scoped=true"
import script from "./InventoryValueReport.vue?vue&type=script&lang=js"
export * from "./InventoryValueReport.vue?vue&type=script&lang=js"

import "./InventoryValueReport.vue?vue&type=style&index=0&id=6a94298c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a94298c"]])

export default __exports__